import Bugsnag from '@bugsnag/js'

// Bugsnag's backend drops extension errors by URL, which misses Firefox sandbox and iOS user-script frames
// (same filter as freelancehunt.com)
const SANDBOX_FRAME = /^(?:<anonymous code>|user-script)/

function isBrowserExtensionNoise(event) {
    const files = event.errors.flatMap((error) => error.stacktrace).map((frame) => frame.file ?? '')
    // Extensions also show up in stacks that run our code, so any URL frame means the event may still be ours
    return files.some((file) => SANDBOX_FRAME.test(file)) && !files.some((file) => file.includes('://'))
}

// JS errors to Bugsnag (#668). <meta name="bugsnag-js"> is there only where BUGSNAG_JS_API_KEY is set (prod),
// so local and CI send nothing
const meta = document.querySelector('meta[name="bugsnag-js"]')
if (meta) {
    Bugsnag.start({
        apiKey: meta.content,
        releaseStage: meta.dataset.stage,
        // Same release commit as the PHP errors (config/bugsnag.php)
        appVersion: meta.dataset.version || undefined,
        onError: (event) => !isBrowserExtensionNoise(event),
    })
}
